import { ButtonGroup } from '@design/components/button-group/ButtonGroup';
import clsx from 'clsx';
import { ReactNode } from 'react';

import styles from './HorizonSelector.module.scss';

export interface HorizonSelectorProps {
  horizonLabels: ReactNode[];
  activeHorizonIndex: number;
  onClick: (index: number) => void;
  className?: string;
  testId?: string;
}

export const HorizonSelector = ({
  horizonLabels,
  activeHorizonIndex,
  onClick,
  className,
  testId = 'horizon-selector',
}: HorizonSelectorProps) => {
  return (
    <div
      className={clsx(styles.horizonSelectorRoot, className)}
      data-testid={testId}
    >
      <ButtonGroup
        className={styles.styledButtonGroup}
        labels={horizonLabels}
        onClick={onClick}
        activeIndex={activeHorizonIndex}
      />
    </div>
  );
};
